import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { IMenuFlowPage } from '@shared/state';

import { WizzardCollapseService } from './wizzard-collapse.service';

@Component({
    selector: 'shared-wizzard-collapse',
    templateUrl: './wizzard-collapse.shared.component.html',
    styleUrls: ['./wizzard-collapse.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizzardCollapseComponent implements OnInit, OnDestroy {
    @Input() public menuFlowPages: IMenuFlowPage[];

    constructor(
        private _wizzardCollapseService: WizzardCollapseService,
    ) { }

    ngOnInit(): void { }

    ngOnDestroy(): void {
        this._wizzardCollapseService.destroy();
    }

    public trackBy(page: IMenuFlowPage, index: number): number {
        return page?.PageIdentifier || index;
    }
}
